import _ from 'underscore';
import { UAPCroppingType, UAPImageExpansionType, setROIInfo } from '@bingads-webui-campaign-react/unified-ad-preview-library-util';
import { getCenterCroppedSettings } from './get-central-crop-settings';

export const getExpandedImageInfo = ({
  imageExpansionType,
  expandedImageUrl,
  expandedImageWidth,
  expandedImageHeight,
  expandedImageCropSettings,
  originalImageCropSettings,
  extraCheck = undefined,
}) => {
  if (!imageExpansionType || imageExpansionType === UAPImageExpansionType.None) {
    return null;
  }

  if (originalImageCropSettings && imageExpansionType !== UAPImageExpansionType.Outpainting && originalImageCropSettings.CroppingType === UAPCroppingType.SmartCrop) {
    return null;
  }

  if (imageExpansionType === UAPImageExpansionType.SingleColorPadding) {
    return null;
  }

  if (!expandedImageCropSettings) {
    return null;
  }

  if (extraCheck && extraCheck()) {
    return null;
  }

  return {
    expandedImageWidth,
    expandedImageHeight,
    expandedImageCropSettings,
    expandedImageUrl,
  };
};

export const getCropSettingsFromRoi = ({
  imageMeta,
  imageCropping,
  placementMetaList, // Array<UPAPlacementMeta>
  useOriginalImageSize = false,
}) => {
  let expandedInfo = {};
  if (imageMeta.expandedMeta) {
    const { expandedMeta } = imageMeta;
    expandedInfo = {
      expandedImageUrl: expandedMeta.expandedImageUrl,
      expandedImageWidth: expandedMeta.expandedImageWidth,
      expandedImageHeight: expandedMeta.expandedImageHeight,
      expandedImageCropSettings: expandedMeta.expandedImageCropSettings,
      originalImageCropSettings: expandedMeta.originalImageCropSettings,
      imageExpansionType: expandedMeta.imageExpansionType,
    };
  } else if (imageMeta.roiInfo) {
    expandedInfo = setROIInfo(imageMeta.roiInfo, imageMeta.url);
  } else {
    return [];
  }

  const {
    expandedImageWidth,
    expandedImageHeight,
    expandedImageCropSettings: expandedImageCropSettingsOriginal,
    originalImageCropSettings,
    expandedImageUrl,
    imageExpansionType,
  } = expandedInfo;

  const aspectRatios = _.pluck(placementMetaList, 'aspectRatio');
  const width = useOriginalImageSize ? imageMeta.originalWidth : imageMeta.width;
  const height = useOriginalImageSize ? imageMeta.originalHeight : imageMeta.height;
  const maxCropBox = imageCropping || {
    SourceWidth: width,
    SourceHeight: height,
    SourceX: 0,
    SourceY: 0,
  };

  const expandedImageCropSettingsMap = _.map(aspectRatios, (ratio) => {
    const cropSetting = _.find(expandedImageCropSettingsOriginal, ({ AspectRatio }) => AspectRatio === ratio);
    return cropSetting ? cropSetting.CropSetting : undefined;
  });

  const originalImageCropSettingsMap = _.map(aspectRatios, (ratio) => {
    const cropSetting = _.find(originalImageCropSettings, ({ AspectRatio }) => AspectRatio === ratio);
    return cropSetting ? cropSetting.CropSetting : { ...getCenterCroppedSettings(maxCropBox, ratio), CroppingType: UAPCroppingType.CenterCrop };
  });

  const placementList = _.map(expandedImageCropSettingsMap, (expandedCropSetting, index) => {
    const expandedImageInfo = getExpandedImageInfo({
      imageExpansionType,
      expandedImageUrl,
      expandedImageWidth,
      expandedImageHeight,
      expandedImageCropSettings: expandedCropSetting,
      originalImageCropSettings: originalImageCropSettingsMap[index],
    });

    if (expandedImageInfo) {
      return {
        ...expandedImageInfo,
        placementCropping: originalImageCropSettingsMap[index],
      };
    }

    return {
      placementCropping: originalImageCropSettingsMap[index],
    };
  });

  return placementList;
};
